// frontend/src/components/pages/admin/organizations/index.jsx
export { default as AllOrgsTab } from './AllOrgsTab';
export { default as UpgradeRequestsTab } from './UpgradeRequestsTab';
export { default as AddOrgModal } from './AddOrgModal';

import React, { useState } from 'react';
import AllOrgsTab from './AllOrgsTab';
import UpgradeRequestsTab from './UpgradeRequestsTab';
import AddOrgModal from './AddOrgModal';

export function OrganizationsTabs(props) {
    const [tab, setTab] = useState('all');
    const {
        organizations,
        isLoadingOrgs,
        handleOrgNameClick,
        handleOrgStatusChange,
        setShowAddOrgModal,
        showAddOrgModal,
        newOrg,
        setNewOrg,
        isLoading,
        handleAddOrganization,
    } = props;

    return (
        <div className="h-full p-6 custom-scrollbar overflow-y-auto">
            <div className="max-w-7xl mx-auto">
                <div className="flex gap-2 mb-6">
                    <button
                        className={`py-1.5 px-4 text-sm font-medium transition-colors duration-150 border-none outline-none focus:outline-none rounded-lg ${
                            tab === 'all'
                                ? 'bg-bg-40 text-fg-90 border-b-2 border-ac-02 shadow-sm'
                                : 'bg-transparent text-fg-60 hover:text-fg-80'
                        }`}
                        style={{ boxShadow: tab === 'all' ? '0 1px 4px 0 rgba(0,0,0,0.03)' : 'none' }}
                        onClick={() => setTab('all')}
                    >
                        All Organizations
                    </button>
                    <button
                        className={`py-1.5 px-4 text-sm font-medium transition-colors duration-150 border-none outline-none focus:outline-none rounded-lg ${
                            tab === 'requests'
                                ? 'bg-bg-40 text-fg-90 border-b-2 border-ac-02 shadow-sm'
                                : 'bg-transparent text-fg-60 hover:text-fg-80'
                        }`}
                        style={{ boxShadow: tab === 'requests' ? '0 1px 4px 0 rgba(0,0,0,0.03)' : 'none' }}
                        onClick={() => setTab('requests')}
                    >
                        Upgrade Requests
                    </button>
                </div>
                {tab === 'all' ? (
                    <AllOrgsTab
                        organizations={organizations}
                        onOrgClick={handleOrgNameClick}
                        onStatusChange={handleOrgStatusChange}
                        onAddOrganization={() => setShowAddOrgModal(true)}
                        loading={isLoadingOrgs}
                    />
                ) : (
                    <UpgradeRequestsTab />
                )}
                <AddOrgModal
                    isOpen={showAddOrgModal}
                    newOrg={newOrg}
                    setNewOrg={setNewOrg}
                    isLoading={isLoading}
                    onClose={() => setShowAddOrgModal(false)}
                    onSubmit={handleAddOrganization}
                />
            </div>
        </div>
    );
} 